import { Typography } from 'components/Contentful'

function MonthlyPayment({ jsonConfig, loanPayments, term, variant }) {
  return (
    <>
      <Typography
        content={jsonConfig?.monthlyPaymentTitle || 'Monthly payment'}
        variant={variant || 'bodyLg'}
        mobileVariant="bodySm"
        responsive={true}
        data-testid="heloc-montly-payment"
        className="text-[#42546B]"
      />
      <Typography
        content={`$${loanPayments[term - 1]?.monthly_payment}`}
        variant="headingMd"
        fontWeight="bold"
        className="py-2"
      />
    </>
  )
}

export { MonthlyPayment }
